import { e as rt } from "./class-map-3ADKve8g.js";
import { P as Pt, b as D, A as at, n as f, t as Nt } from "./element-CV9utnHJ.js";
import { r as Z } from "./state-l4hGZdFJ.js";
import "./icon-D0IQAVwS.js";
const yt = 6048e5, Ct = 864e5, st = Symbol.for("constructDateFrom");
function k(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && st in t ? t[st](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function b(t, e) {
  return k(e || t, t);
}
function it(t, e, n) {
  const r = b(t, n == null ? void 0 : n.in);
  return isNaN(e) ? k(t, NaN) : (e && r.setDate(r.getDate() + e), r);
}
let $t = {};
function B() {
  return $t;
}
function R(t, e) {
  var o, c, d, g;
  const n = B(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((c = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((g = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : g.weekStartsOn) ?? 0, a = b(t, e == null ? void 0 : e.in), s = a.getDay(), i = (s < r ? 7 : 0) + s - r;
  return a.setDate(a.getDate() - i), a.setHours(0, 0, 0, 0), a;
}
function q(t, e) {
  return R(t, { ...e, weekStartsOn: 1 });
}
function pt(t, e) {
  const n = b(t, e == null ? void 0 : e.in), r = n.getFullYear(), a = k(n, 0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const s = q(a), i = k(n, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const o = q(i);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= o.getTime() ? r : r - 1;
}
function ot(t) {
  const e = b(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function wt(t, ...e) {
  const n = k.bind(
    null,
    e.find((r) => typeof r == "object")
  );
  return e.map(n);
}
function K(t, e) {
  const n = b(t, e == null ? void 0 : e.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Et(t, e, n) {
  const [r, a] = wt(
    n == null ? void 0 : n.in,
    t,
    e
  ), s = K(r), i = K(a), o = +s - ot(s), c = +i - ot(i);
  return Math.round((o - c) / Ct);
}
function _t(t, e) {
  const n = pt(t, e), r = k(t, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), q(r);
}
function Wt(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Yt(t) {
  return !(!Wt(t) && typeof t != "number" || isNaN(+b(t)));
}
function Ft(t, e) {
  const n = b(t, e == null ? void 0 : e.in);
  return n.setHours(23, 59, 59, 999), n;
}
function It(t, e) {
  const [n, r] = wt(t, e.start, e.end);
  return { start: n, end: r };
}
function bt(t, e) {
  const { start: n, end: r } = It(e == null ? void 0 : e.in, t);
  let a = +n > +r;
  const s = a ? +n : +r, i = a ? r : n;
  i.setHours(0, 0, 0, 0);
  let o = 1;
  const c = [];
  for (; +i <= s; )
    c.push(k(n, i)), i.setDate(i.getDate() + o), i.setHours(0, 0, 0, 0);
  return a ? c.reverse() : c;
}
function At(t, e) {
  const n = b(t, e == null ? void 0 : e.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const Ht = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Rt = (t, e, n) => {
  let r;
  const a = Ht[t];
  return typeof a == "string" ? r = a : e === 1 ? r = a.one : r = a.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function X(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const Ut = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Lt = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, qt = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Bt = {
  date: X({
    formats: Ut,
    defaultWidth: "full"
  }),
  time: X({
    formats: Lt,
    defaultWidth: "full"
  }),
  dateTime: X({
    formats: qt,
    defaultWidth: "full"
  })
}, zt = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, jt = (t, e, n, r) => zt[t];
function F(t) {
  return (e, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let a;
    if (r === "formatting" && t.formattingValues) {
      const i = t.defaultFormattingWidth || t.defaultWidth, o = n != null && n.width ? String(n.width) : i;
      a = t.formattingValues[o] || t.formattingValues[i];
    } else {
      const i = t.defaultWidth, o = n != null && n.width ? String(n.width) : t.defaultWidth;
      a = t.values[o] || t.values[i];
    }
    const s = t.argumentCallback ? t.argumentCallback(e) : e;
    return a[s];
  };
}
const Qt = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Xt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Gt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Vt = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Kt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Jt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Zt = (t, e) => {
  const n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, te = {
  ordinalNumber: Zt,
  era: F({
    values: Qt,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: Xt,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: F({
    values: Gt,
    defaultWidth: "wide"
  }),
  day: F({
    values: Vt,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: Kt,
    defaultWidth: "wide",
    formattingValues: Jt,
    defaultFormattingWidth: "wide"
  })
};
function I(t) {
  return (e, n = {}) => {
    const r = n.width, a = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], s = e.match(a);
    if (!s)
      return null;
    const i = s[0], o = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], c = Array.isArray(o) ? ne(o, (m) => m.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      ee(o, (m) => m.test(i))
    );
    let d;
    d = t.valueCallback ? t.valueCallback(c) : c, d = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(d)
    ) : d;
    const g = e.slice(i.length);
    return { value: d, rest: g };
  };
}
function ee(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function ne(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function re(t) {
  return (e, n = {}) => {
    const r = e.match(t.matchPattern);
    if (!r) return null;
    const a = r[0], s = e.match(t.parsePattern);
    if (!s) return null;
    let i = t.valueCallback ? t.valueCallback(s[0]) : s[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const o = e.slice(a.length);
    return { value: i, rest: o };
  };
}
const ae = /^(\d+)(th|st|nd|rd)?/i, se = /\d+/i, ie = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, oe = {
  any: [/^b/i, /^(a|c)/i]
}, ce = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, ue = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, le = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, he = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, de = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, fe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, me = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ge = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ye = {
  ordinalNumber: re({
    matchPattern: ae,
    parsePattern: se,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: I({
    matchPatterns: ie,
    defaultMatchWidth: "wide",
    parsePatterns: oe,
    defaultParseWidth: "any"
  }),
  quarter: I({
    matchPatterns: ce,
    defaultMatchWidth: "wide",
    parsePatterns: ue,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: I({
    matchPatterns: le,
    defaultMatchWidth: "wide",
    parsePatterns: he,
    defaultParseWidth: "any"
  }),
  day: I({
    matchPatterns: de,
    defaultMatchWidth: "wide",
    parsePatterns: fe,
    defaultParseWidth: "any"
  }),
  dayPeriod: I({
    matchPatterns: me,
    defaultMatchWidth: "any",
    parsePatterns: ge,
    defaultParseWidth: "any"
  })
}, pe = {
  code: "en-US",
  formatDistance: Rt,
  formatLong: Bt,
  formatRelative: jt,
  localize: te,
  match: ye,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function we(t, e) {
  const n = b(t, e == null ? void 0 : e.in);
  return Et(n, At(n)) + 1;
}
function be(t, e) {
  const n = b(t, e == null ? void 0 : e.in), r = +q(n) - +_t(n);
  return Math.round(r / yt) + 1;
}
function Dt(t, e) {
  var g, m, v, M;
  const n = b(t, e == null ? void 0 : e.in), r = n.getFullYear(), a = B(), s = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((m = (g = e == null ? void 0 : e.locale) == null ? void 0 : g.options) == null ? void 0 : m.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((M = (v = a.locale) == null ? void 0 : v.options) == null ? void 0 : M.firstWeekContainsDate) ?? 1, i = k((e == null ? void 0 : e.in) || t, 0);
  i.setFullYear(r + 1, 0, s), i.setHours(0, 0, 0, 0);
  const o = R(i, e), c = k((e == null ? void 0 : e.in) || t, 0);
  c.setFullYear(r, 0, s), c.setHours(0, 0, 0, 0);
  const d = R(c, e);
  return +n >= +o ? r + 1 : +n >= +d ? r : r - 1;
}
function De(t, e) {
  var o, c, d, g;
  const n = B(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((c = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : c.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((g = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : g.firstWeekContainsDate) ?? 1, a = Dt(t, e), s = k((e == null ? void 0 : e.in) || t, 0);
  return s.setFullYear(a, 0, r), s.setHours(0, 0, 0, 0), R(s, e);
}
function St(t, e) {
  const n = b(t, e == null ? void 0 : e.in), r = +R(n, e) - +De(n, e);
  return Math.round(r / yt) + 1;
}
function u(t, e) {
  const n = t < 0 ? "-" : "", r = Math.abs(t).toString().padStart(e, "0");
  return n + r;
}
const T = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), r = n > 0 ? n : 1 - n;
    return u(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : u(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return u(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return u(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return u(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return u(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return u(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, r = t.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return u(a, e.length);
  }
}, E = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ct = {
  // Era
  G: function(t, e, n) {
    const r = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const r = t.getFullYear(), a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, { unit: "year" });
    }
    return T.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, r) {
    const a = Dt(t, r), s = a > 0 ? a : 1 - a;
    if (e === "YY") {
      const i = s % 100;
      return u(i, 2);
    }
    return e === "Yo" ? n.ordinalNumber(s, { unit: "year" }) : u(s, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = pt(t);
    return u(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return u(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return u(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return u(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return T.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return u(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, r) {
    const a = St(t, r);
    return e === "wo" ? n.ordinalNumber(a, { unit: "week" }) : u(a, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const r = be(t);
    return e === "Io" ? n.ordinalNumber(r, { unit: "week" }) : u(r, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : T.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const r = we(t);
    return e === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : u(r, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const r = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, r) {
    const a = t.getDay(), s = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(s);
      // Padded numerical value
      case "ee":
        return u(s, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(s, { unit: "day" });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, r) {
    const a = t.getDay(), s = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(s);
      // Padded numerical value
      case "cc":
        return u(s, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const r = t.getDay(), a = r === 0 ? 7 : r;
    switch (e) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return u(a, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const a = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const r = t.getHours();
    let a;
    switch (r === 12 ? a = E.noon : r === 0 ? a = E.midnight : a = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const r = t.getHours();
    let a;
    switch (r >= 17 ? a = E.evening : r >= 12 ? a = E.afternoon : r >= 4 ? a = E.morning : a = E.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let r = t.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return T.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : T.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const r = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : u(r, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let r = t.getHours();
    return r === 0 && (r = 24), e === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : u(r, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : T.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : T.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return T.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const r = t.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return lt(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return N(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return N(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return lt(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return N(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return N(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ut(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + N(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ut(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + N(r, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const r = Math.trunc(+t / 1e3);
    return u(r, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return u(+t, e.length);
  }
};
function ut(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), a = Math.trunc(r / 60), s = r % 60;
  return s === 0 ? n + String(a) : n + String(a) + e + u(s, 2);
}
function lt(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + u(Math.abs(t) / 60, 2) : N(t, e);
}
function N(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), a = u(Math.trunc(r / 60), 2), s = u(r % 60, 2);
  return n + a + e + s;
}
const ht = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, kt = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, Se = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], r = n[1], a = n[2];
  if (!a)
    return ht(t, e);
  let s;
  switch (r) {
    case "P":
      s = e.dateTime({ width: "short" });
      break;
    case "PP":
      s = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = e.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", ht(r, e)).replace("{{time}}", kt(a, e));
}, ke = {
  p: kt,
  P: Se
}, ve = /^D+$/, Me = /^Y+$/, Te = ["D", "DD", "YY", "YYYY"];
function xe(t) {
  return ve.test(t);
}
function Oe(t) {
  return Me.test(t);
}
function Pe(t, e, n) {
  const r = Ne(t, e, n);
  if (console.warn(r), Te.includes(t)) throw new RangeError(r);
}
function Ne(t, e, n) {
  const r = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Ce = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $e = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ee = /^'([^]*?)'?$/, _e = /''/g, We = /[a-zA-Z]/;
function Ye(t, e, n) {
  var g, m, v, M;
  const r = B(), a = r.locale ?? pe, s = r.firstWeekContainsDate ?? ((m = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, i = r.weekStartsOn ?? ((M = (v = r.locale) == null ? void 0 : v.options) == null ? void 0 : M.weekStartsOn) ?? 0, o = b(t, n == null ? void 0 : n.in);
  if (!Yt(o))
    throw new RangeError("Invalid time value");
  let c = e.match($e).map((w) => {
    const p = w[0];
    if (p === "p" || p === "P") {
      const Y = ke[p];
      return Y(w, a.formatLong);
    }
    return w;
  }).join("").match(Ce).map((w) => {
    if (w === "''")
      return { isToken: !1, value: "'" };
    const p = w[0];
    if (p === "'")
      return { isToken: !1, value: Fe(w) };
    if (ct[p])
      return { isToken: !0, value: w };
    if (p.match(We))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + p + "`"
      );
    return { isToken: !1, value: w };
  });
  a.localize.preprocessor && (c = a.localize.preprocessor(o, c));
  const d = {
    firstWeekContainsDate: s,
    weekStartsOn: i,
    locale: a
  };
  return c.map((w) => {
    if (!w.isToken) return w.value;
    const p = w.value;
    (Oe(p) || xe(p)) && Pe(p, e, String(t));
    const Y = ct[p[0]];
    return Y(o, p, a.localize, d);
  }).join("");
}
function Fe(t) {
  const e = t.match(Ee);
  return e ? e[1].replace(_e, "'") : t;
}
function Ie(t, e) {
  const n = b(t, e == null ? void 0 : e.in).getDay();
  return n === 0 ? 7 : n;
}
function Ae(t, e, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: t,
    timeZoneName: n
  }).format(e).split(/\s/g).slice(2).join(" ");
}
const G = {}, H = {};
function C(t, e) {
  try {
    const r = (G[t] || (G[t] = new Intl.DateTimeFormat("en-US", {
      timeZone: t,
      timeZoneName: "longOffset"
    }).format))(e).split("GMT")[1];
    return r in H ? H[r] : dt(r, r.split(":"));
  } catch {
    if (t in H) return H[t];
    const n = t == null ? void 0 : t.match(He);
    return n ? dt(t, n.slice(1)) : NaN;
  }
}
const He = /([+-]\d\d):?(\d\d)?/;
function dt(t, e) {
  const n = +(e[0] || 0), r = +(e[1] || 0), a = +(e[2] || 0) / 60;
  return H[t] = n * 60 + r > 0 ? n * 60 + r + a : n * 60 - r - a;
}
class S extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(C(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), vt(this), J(this)) : this.setTime(Date.now());
  }
  static tz(e, ...n) {
    return n.length ? new S(...n, e) : new S(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new S(+this, e);
  }
  getTimezoneOffset() {
    const e = -C(this.timeZone, this);
    return e > 0 ? Math.floor(e) : Math.ceil(e);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), J(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new S(+new Date(e), this.timeZone);
  }
  //#endregion
}
const ft = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((t) => {
  if (!ft.test(t)) return;
  const e = t.replace(ft, "$1UTC");
  S.prototype[e] && (t.startsWith("get") ? S.prototype[t] = function() {
    return this.internal[e]();
  } : (S.prototype[t] = function() {
    return Date.prototype[e].apply(this.internal, arguments), Re(this), +this;
  }, S.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), J(this), +this;
  }));
});
function J(t) {
  t.internal.setTime(+t), t.internal.setUTCSeconds(t.internal.getUTCSeconds() - Math.round(-C(t.timeZone, t) * 60));
}
function Re(t) {
  Date.prototype.setFullYear.call(t, t.internal.getUTCFullYear(), t.internal.getUTCMonth(), t.internal.getUTCDate()), Date.prototype.setHours.call(t, t.internal.getUTCHours(), t.internal.getUTCMinutes(), t.internal.getUTCSeconds(), t.internal.getUTCMilliseconds()), vt(t);
}
function vt(t) {
  const e = C(t.timeZone, t), n = e > 0 ? Math.floor(e) : Math.ceil(e), r = /* @__PURE__ */ new Date(+t);
  r.setUTCHours(r.getUTCHours() - 1);
  const a = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset(), s = -(/* @__PURE__ */ new Date(+r)).getTimezoneOffset(), i = a - s, o = Date.prototype.getHours.apply(t) !== t.internal.getUTCHours();
  i && o && t.internal.setUTCMinutes(t.internal.getUTCMinutes() + i);
  const c = a - n;
  c && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + c);
  const d = /* @__PURE__ */ new Date(+t);
  d.setUTCSeconds(0);
  const g = a > 0 ? d.getSeconds() : (d.getSeconds() - 60) % 60, m = Math.round(-(C(t.timeZone, t) * 60)) % 60;
  (m || g) && (t.internal.setUTCSeconds(t.internal.getUTCSeconds() + m), Date.prototype.setUTCSeconds.call(t, Date.prototype.getUTCSeconds.call(t) + m + g));
  const v = C(t.timeZone, t), M = v > 0 ? Math.floor(v) : Math.ceil(v), p = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset() - M, Y = M !== n, nt = p - c;
  if (Y && nt) {
    Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + nt);
    const j = C(t.timeZone, t), Ot = j > 0 ? Math.floor(j) : Math.ceil(j), Q = M - Ot;
    Q && (t.internal.setUTCMinutes(t.internal.getUTCMinutes() + Q), Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + Q));
  }
}
class x extends S {
  //#region static
  static tz(e, ...n) {
    return n.length ? new x(...n, e) : new x(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, n, r] = this.tzComponents(), a = `${e}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + a;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, n, r, a] = this.internal.toUTCString().split(" ");
    return `${e == null ? void 0 : e.slice(0, -1)} ${r} ${n} ${a}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [n, r, a] = this.tzComponents();
    return `${e} GMT${n}${r}${a} (${Ae(this.timeZone, this)})`;
  }
  toLocaleString(e, n) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(e, n) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(e, n) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), n = e > 0 ? "-" : "+", r = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), a = String(Math.abs(e) % 60).padStart(2, "0");
    return [n, r, a];
  }
  //#endregion
  withTimeZone(e) {
    return new x(+this, e);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new x(+new Date(e), this.timeZone);
  }
  //#endregion
}
window.pktTz = window.pktTz === void 0 ? "Europe/Oslo" : window.pktTz;
const Ue = (t = window.pktTz) => {
  const e = new x((/* @__PURE__ */ new Date()).toISOString(), t);
  return e.setHours(0, 0, 0, 0), isNaN(e.getTime()) ? /* @__PURE__ */ new Date() : new Date(e.getFullYear(), e.getMonth(), e.getDate());
};
function O(t) {
  if (!t || t === "") return /* @__PURE__ */ new Date();
  if (/^\d{4}-\d{2}-\d{2}$/.test(t)) {
    const [e, n, r] = t.split("-").map(Number);
    return new Date(e, n - 1, r);
  }
  if (/^\d{4}-\d{2}$/.test(t)) {
    const [e, n] = t.split("-").map(Number);
    return new Date(e, n - 1, 1);
  }
  return /^\d{4}$/.test(t) ? new Date(Number(t), 0, 1) : new Date(t);
}
const y = (t) => {
  if (!t || isNaN(t.getTime())) return "";
  const e = t.getFullYear(), n = String(t.getMonth() + 1).padStart(2, "0"), r = String(t.getDate()).padStart(2, "0");
  return `${e}-${n}-${r}`;
}, U = (t) => {
  if (!t)
    return null;
  const e = O(t);
  return isNaN(e.getTime()) ? null : e;
}, pn = (t, e) => {
  const n = W(t);
  return isNaN(n.getTime()) ? "" : Ye(n, e);
}, W = (t = "", e) => {
  const n = typeof t == "string" ? O(t) : t;
  return !n || isNaN(n.getTime()) ? /* @__PURE__ */ new Date() : e ? e === "end" ? Ft(n) : K(n) : n;
}, $ = (t, e, n = 1) => {
  if (typeof t != "number" || typeof e != "number" || typeof n != "number" || isNaN(t) || isNaN(e) || isNaN(n))
    return /* @__PURE__ */ new Date();
  const r = new Date(t, e, n);
  return isNaN(r.getTime()) ? /* @__PURE__ */ new Date() : r;
}, A = (t) => {
  let e;
  return typeof t == "number" ? e = new x(t, window.pktTz) : e = new x(t, window.pktTz), e.setHours(12, 0, 0, 0), e;
};
let V = null, mt;
const Le = (t) => {
  if (!t || isNaN(t.getTime())) return "";
  const e = typeof window < "u" ? window.pktTz : void 0;
  return (!V || mt !== e) && (V = new Intl.DateTimeFormat("no", { dateStyle: "full", timeZone: e }), mt = e), V.format(t);
}, qe = (t, e, n) => {
  if (!t || isNaN(t.getTime())) return !1;
  const r = e ? W(e) : null, a = n ? W(n) : null;
  return !(r && t < r || a && t > a);
}, Be = (t, e) => {
  if (!t || isNaN(t.getTime()) || !Array.isArray(e)) return !1;
  const n = y(t);
  return e.includes(n);
}, ze = (t, e) => {
  if (!t || isNaN(t.getTime()) || !Array.isArray(e)) return !1;
  const n = t.getDay().toString();
  return e.includes(n);
}, Mt = (t, e, n, r, a) => !(!t || isNaN(t.getTime()) || !qe(t, e, n) || r && Be(t, r) || a && ze(t, a)), wn = (t, e, n, r, a) => t.filter((s) => {
  const i = U(s);
  return i && Mt(i, e, n, r, a);
}), bn = (t) => t.slice().sort((e, n) => {
  const r = U(e), a = U(n);
  return !r || !a ? 0 : r.getTime() - a.getTime();
}), Dn = (t, e) => {
  const n = U(t), r = U(e);
  return !n || !r ? !1 : n <= r;
}, je = (t) => t ? Array.isArray(t) ? t.filter(Boolean) : String(t).split(",").map((e) => e.trim()).filter(Boolean) : [], Sn = (t) => t.join(","), Qe = (t) => je(t), Xe = (t) => t ? O(t) : null, Ge = (t) => {
  if (typeof t == "string")
    return t.split(",").map((e) => O(e));
  if (Array.isArray(t))
    return t.map((e) => O(e));
}, z = {
  csvToArray: Qe,
  stringToDate: Xe,
  stringsToDate: Ge
}, Ve = { earliest: { default: null }, latest: { default: null }, weeknumbers: { default: !1 }, withcontrols: { default: !1 }, multiple: { default: !1 }, maxMultiple: { default: 4 }, range: { default: !1 } }, P = {
  props: Ve
};
function Tt(t, e) {
  const n = (e.excludedates ?? []).map(
    (r) => typeof r == "string" ? r : y(r)
  );
  return !Mt(
    t,
    e.earliest,
    e.latest,
    n,
    e.excludeweekdays ?? []
  );
}
function Ke(t, e, n, r) {
  return !!(Tt(t, n) || !e && r.multiple && r.maxMultiple > 0 && r.selectedCount >= r.maxMultiple);
}
function Je(t, e, n) {
  const r = $(t, e, 0);
  return !(n && W(n) > r);
}
function Ze(t, e, n) {
  const r = $(
    e === 11 ? t + 1 : t,
    e === 11 ? 0 : e + 1,
    1
  );
  return !(n && W(n) < r);
}
const L = 7, tn = 6;
function en(t, e) {
  const n = $(t, e, 1), r = $(t, e + 1, 0), a = (n.getDay() + tn) % L, s = r.getDate(), i = Math.ceil((s + a) / L), c = $(t, e, 0).getDate(), d = St(n);
  return {
    firstDayOfMonth: n,
    lastDayOfMonth: r,
    startingDay: a,
    numDays: s,
    numRows: i,
    numDaysPrevMonth: c,
    initialWeek: d
  };
}
function nn(t, e, n, r) {
  const { startingDay: a, numDays: s } = r;
  return t === 0 && e < a ? "prev-month" : n > s ? "next-month" : "current-month";
}
function rn(t, e, n, r) {
  const { startingDay: a, numDaysPrevMonth: s, numDays: i } = r;
  return t === "prev-month" ? s - (a - e - 1) : t === "next-month" ? n - i : n;
}
function _(t) {
  return typeof t == "string" && (t = t.split(",")), t.length === 1 && t[0] === "" ? [] : t.map((e) => O(e));
}
function gt(t, e) {
  const n = bt({ start: t, end: e }), r = {};
  if (Array.isArray(n) && n.length)
    for (let a = 0; a < n.length; a++) {
      const s = n[a], i = s > t && s < e;
      r[y(s)] = i;
    }
  return r;
}
function xt(t, e, n, r) {
  if (e.length !== 1) return !0;
  const a = bt({
    start: e[0],
    end: t
  });
  if (!Array.isArray(a) || !a.length) return !0;
  for (let s = 0; s < a.length; s++) {
    for (const i of n ?? [])
      if (i > e[0] && i < t)
        return !1;
    if ((r ?? []).includes(Ie(a[s]).toString()))
      return !1;
  }
  return !0;
}
function tt(t, e) {
  const n = y(t);
  return e.includes(n) ? e : [...e, n];
}
function et(t, e) {
  const n = y(t), r = e.indexOf(n);
  if (r === -1) return e;
  if (e.length === 1) return [];
  const a = [...e];
  return a.splice(r, 1), a;
}
function an(t, e, n) {
  const r = y(t);
  return e.includes(r) ? et(t, e) : n > 0 && e.length >= n ? e : tt(t, e);
}
function sn(t, e, n) {
  const r = y(t), a = _(e);
  if (e.includes(r))
    return e.indexOf(r) === 0 ? [] : et(t, e);
  if (e.length > 1)
    return [r];
  if (e.length === 1) {
    if (!xt(t, a, n.excludedates, n.excludeweekdays))
      return [r];
    if (a[0] > t)
      return [r];
  }
  return tt(t, e);
}
const on = {
  ArrowLeft: -1,
  ArrowRight: 1,
  ArrowUp: -L,
  ArrowDown: L
};
function cn(t) {
  var n;
  const e = t.nodeName;
  return e === "INPUT" || e === "SELECT" || e === "BUTTON" && !((n = t.dataset) != null && n.date);
}
function un(t, e, n) {
  let r = it(t, e);
  if (!r) return null;
  let a = n(`button[data-date="${y(r)}"]`);
  for (; a instanceof HTMLButtonElement && a.dataset.disabled; )
    if (r = it(r, e), a = n(`button[data-date="${y(r)}"]`), !a) return null;
  return r;
}
function ln(t) {
  return on[t] ?? null;
}
var hn = Object.defineProperty, dn = Object.getOwnPropertyDescriptor, h = (t, e, n, r) => {
  for (var a = r > 1 ? void 0 : r ? dn(e, n) : e, s = t.length - 1, i; s >= 0; s--)
    (i = t[s]) && (a = (r ? i(e, n, a) : i(a)) || a);
  return r && a && hn(e, n, a), a;
};
let l = class extends Pt {
  constructor() {
    super(...arguments), this.selected = [], this.multiple = P.props.multiple.default, this.maxMultiple = P.props.maxMultiple.default, this.range = P.props.range.default, this.earliest = P.props.earliest.default, this.latest = P.props.latest.default, this.excludedates = [], this.excludeweekdays = [], this.weeknumbers = P.props.weeknumbers.default, this.withcontrols = P.props.withcontrols.default, this.currentmonth = null, this.today = null, this.dayStrings = this.strings.dates.daysShort, this.dayStringsLong = this.strings.dates.days, this.monthStrings = this.strings.dates.months, this.weekString = this.strings.dates.week, this.prevMonthString = this.strings.dates.prevMonth, this.nextMonthString = this.strings.dates.nextMonth, this._selected = [], this.inRange = {}, this.rangeHovered = null, this.year = 0, this.month = 0, this.week = 0, this.currentmonthtouched = !1, this.focusedDate = null, this.selectableDates = [], this.tabIndexSet = 0;
  }
  get todayDate() {
    return this.today ? O(this.today) : Ue();
  }
  /**
   * Lifecycle methods
   */
  firstUpdated(t) {
    this.addEventListener("keydown", this.handleKeydown);
  }
  disconnectedCallback() {
    this.removeEventListener("keydown", this.handleKeydown), super.disconnectedCallback();
  }
  updated(t) {
    super.updated(t), t.has("selected") && this.convertSelected();
  }
  /**
   * Date and selection management
   */
  convertSelected() {
    typeof this.selected == "string" && (this.selected = this.selected.split(",")), this.selected.length === 1 && this.selected[0] === "" && (this.selected = []), this._selected = _(this.selected), this.range && this.selected.length === 2 && (this.inRange = gt(this._selected[0], this._selected[1])), this.setCurrentMonth();
  }
  setCurrentMonth() {
    if (this.currentmonth === null && !this.currentmonthtouched && (this.currentmonthtouched = !0), this.selected.length && this.selected[0] !== "") {
      const t = O(this.selected[this.selected.length - 1]);
      this.currentmonth = isNaN(t.getTime()) ? A(this.todayDate) : t;
    } else this.currentmonth === null && (this.currentmonth = A(this.todayDate));
    (!this.currentmonth || isNaN(this.currentmonth.getTime())) && (this.currentmonth = A(this.todayDate)), this.year = this.currentmonth.getFullYear(), this.month = this.currentmonth.getMonth();
  }
  /**
   * Keyboard navigation
   */
  handleKeydown(t) {
    const e = ln(t.key);
    e !== null && this.handleArrowKey(t, e);
  }
  handleArrowKey(t, e) {
    const n = t.target;
    if (cn(n)) return;
    if (t.preventDefault(), !this.focusedDate) {
      this.focusOnCurrentDate();
      return;
    }
    const r = this.focusedDate ? W(this.focusedDate) : $(this.year, this.month, 1), a = un(r, e, this.querySelector.bind(this));
    if (a) {
      const s = this.querySelector(`button[data-date="${y(a)}"]`);
      s instanceof HTMLButtonElement && !s.dataset.disabled && (this.focusedDate = y(a), s.focus());
    }
  }
  /**
   * Rendering methods
   */
  render() {
    return D`
      <div
        class="pkt-calendar ${this.weeknumbers ? "pkt-cal-weeknumbers" : ""}"
        @focusout=${this.closeEvent}
        @keydown=${(t) => {
      t.key === "Escape" && (t.preventDefault(), this.close());
    }}
      >
        <nav class="pkt-cal-month-nav">
          ${this.renderMonthNavButton("prev")}
          ${this.renderMonthNav()}
          ${this.renderMonthNavButton("next")}
        </nav>
        <table
          class="pkt-cal-days pkt-txt-12-medium pkt-calendar__body"
          role="grid"
          ?aria-multiselectable=${this.range || this.multiple}
        >
          <thead>
            ${this.renderDayNames()}
          </thead>
          <tbody>
            ${this.renderCalendarBody()}
          </tbody>
        </table>
      </div>
    `;
  }
  renderMonthNavButton(t) {
    const e = t === "prev", n = e ? this.isPrevMonthAllowed() : this.isNextMonthAllowed(), r = e ? this.prevMonthString : this.nextMonthString, a = e ? "chevron-thin-left" : "chevron-thin-right", s = e ? "pkt-calendar__prev-month" : "pkt-calendar__next-month", i = e ? () => this.prevMonth() : () => this.nextMonth();
    return D`<div>
      <button
        type="button"
        aria-label="${r}"
        @click=${() => n && i()}
        @keydown=${(o) => {
      (o.key === "Enter" || o.key === " ") && (o.preventDefault(), n && i());
    }}
        class="pkt-btn pkt-btn--tertiary pkt-btn--small pkt-btn--icon-only ${s} ${n ? "" : "pkt-invisible"}"
        .data-disabled=${n ? at : "disabled"}
        ?aria-disabled=${!n}
        tabindex=${n ? "0" : "-1"}
      >
        <pkt-icon class="pkt-btn__icon" name="${a}"></pkt-icon>
        <span class="pkt-btn__text">${r}</span>
      </button>
    </div>`;
  }
  renderDayNames() {
    const t = [];
    this.weeknumbers && t.push(D`<th><div class="pkt-calendar__week-number">${this.weekString}</div></th>`);
    for (let e = 0; e < this.dayStrings.length; e++)
      t.push(
        D`<th>
          <div class="pkt-calendar__day-name" aria-label="${this.dayStringsLong[e]}">
            ${this.dayStrings[e]}
          </div>
        </th>`
      );
    return D`<tr class="pkt-cal-week-row">${t}</tr>`;
  }
  renderMonthNav() {
    return this.withcontrols ? D`<div class="pkt-cal-month-picker">
        <label for="${this.id}-monthnav" class="pkt-hide">${this.strings.dates.month}</label>
        <select
          aria-label="${this.strings.dates.month}"
          class="pkt-input pkt-input-compact"
          id="${this.id}-monthnav"
          @change=${(t) => {
      t.stopImmediatePropagation();
      const e = t.target;
      this.changeMonth(this.year, parseInt(e.value));
    }}
        >
          ${this.monthStrings.map(
      (t, e) => D`<option value=${e} ?selected=${this.month === e}>${t}</option>`
    )}
        </select>
        <label for="${this.id}-yearnav" class="pkt-hide">${this.strings.dates.year}</label>
        <input
          aria-label="${this.strings.dates.year}"
          class="pkt-input pkt-cal-input-year pkt-input-compact"
          id="${this.id}-yearnav"
          type="number"
          size="4"
          placeholder="0000"
          @change=${(t) => {
      t.stopImmediatePropagation();
      const e = t.target;
      this.changeMonth(parseInt(e.value), this.month);
    }}
          .value=${this.year}
        />
      </div>` : D`<div class="pkt-txt-16-medium pkt-calendar__month-title" aria-live="polite">
      ${this.monthStrings[this.month]} ${this.year}
    </div>`;
  }
  getDayViewData(t, e) {
    const n = $(this.year, this.month, t), r = y(n), a = r === y(e), s = this.selected.includes(r), i = this.isDayDisabled(n, s), o = this.calculateTabIndex(r, i, t);
    return {
      currentDate: n,
      currentDateISO: r,
      isToday: a,
      isSelected: s,
      isDisabled: i,
      ariaLabel: Le(n),
      tabindex: o
    };
  }
  getDateConstraints() {
    return {
      earliest: this.earliest,
      latest: this.latest,
      excludedates: this.excludedates,
      excludeweekdays: this.excludeweekdays
    };
  }
  isDayDisabled(t, e) {
    return Ke(t, e, this.getDateConstraints(), {
      multiple: this.multiple,
      maxMultiple: this.maxMultiple,
      selectedCount: this.selected.length
    });
  }
  calculateTabIndex(t, e, n) {
    return this.focusedDate ? this.focusedDate === t && !e ? "0" : "-1" : !e && this.tabIndexSet === 0 ? (this.tabIndexSet = n, "0") : this.tabIndexSet === n ? "0" : "-1";
  }
  getDayCellClasses(t) {
    const { currentDateISO: e, isToday: n, isSelected: r } = t, a = this.range && (this.selected.length === 2 || this.rangeHovered !== null) && e === this.selected[0], s = this.range && this.selected.length === 2 && e === this.selected[1];
    return {
      "pkt-cal-today": n,
      "pkt-cal-selected": r,
      "pkt-cal-in-range": this.inRange[e],
      "pkt-cal-excluded": this.isExcluded(t.currentDate),
      "pkt-cal-in-range-first": a,
      "pkt-cal-in-range-last": s,
      "pkt-cal-range-hover": this.rangeHovered !== null && e === y(this.rangeHovered)
    };
  }
  getDayButtonClasses(t) {
    const { currentDateISO: e, isToday: n, isSelected: r, isDisabled: a } = t, s = this.range && (this.selected.length === 2 || this.rangeHovered !== null) && e === this.selected[0], i = this.range && this.selected.length === 2 && e === this.selected[1];
    return {
      "pkt-calendar__date": !0,
      "pkt-calendar__date--today": n,
      "pkt-calendar__date--selected": r,
      "pkt-calendar__date--disabled": a,
      "pkt-calendar__date--in-range": this.inRange[e],
      "pkt-calendar__date--in-range-hover": this.rangeHovered !== null && e === y(this.rangeHovered),
      "pkt-calendar__date--range-start": s,
      "pkt-calendar__date--range-end": i
    };
  }
  handleDayFocus(t, e) {
    this.range && !this.isExcluded(t) && this.handleRangeHover(t), this.focusedDate = e;
  }
  renderDayView(t, e) {
    const n = this.getDayViewData(t, e), { currentDate: r, currentDateISO: a, isSelected: s, isDisabled: i, ariaLabel: o, tabindex: c } = n;
    this.selectableDates.push({ currentDateISO: a, isDisabled: i, tabindex: c });
    const d = this.getDayCellClasses(n), g = this.getDayButtonClasses(n);
    return D`<td class=${rt(d)}>
      <button
        type="button"
        aria-pressed=${s ? "true" : "false"}
        ?disabled=${i}
        class="pkt-btn pkt-btn--tertiary pkt-btn--small pkt-btn--label-only ${rt(g)}"
        @mouseover=${() => this.range && !this.isExcluded(r) && this.handleRangeHover(r)}
        @focus=${() => this.handleDayFocus(r, a)}
        aria-label="${o}"
        tabindex=${c}
        data-disabled=${i ? "disabled" : at}
        data-date=${a}
        @keydown=${(m) => {
      (m.key === "Enter" || m.key === " ") && (m.preventDefault(), this.handleDateSelect(r));
    }}
        @click=${(m) => {
      i || (m.preventDefault(), this.handleDateSelect(r));
    }}
      >
        <span class="pkt-btn__text pkt-txt-14-light">${t}</span>
      </button>
    </td>`;
  }
  renderEmptyDayCell(t) {
    return D`<td class="pkt-cal-other">
      <div
        class="pkt-btn pkt-btn--tertiary pkt-btn--small pkt-btn--label-only"
        data-disabled="disabled"
      >
        <span class="pkt-btn__text pkt-txt-14-light">${t}</span>
      </div>
    </td>`;
  }
  renderWeekRow(t) {
    return D`<tr class="pkt-cal-week-row" role="row">${t}</tr>`;
  }
  renderCalendarBody() {
    const t = this.todayDate, e = en(this.year, this.month);
    this.selectableDates = [], this.tabIndexSet = 0;
    let n = 1;
    this.week = e.initialWeek;
    const r = [];
    for (let a = 0; a < e.numRows; a++) {
      const s = [];
      this.weeknumbers && s.push(D`<td class="pkt-cal-week">${this.week}</td>`), this.week++;
      for (let i = 0; i < L; i++) {
        const o = nn(a, i, n, e);
        if (o === "current-month")
          s.push(this.renderDayView(n, t)), n++;
        else {
          const c = rn(o, i, n, e);
          s.push(this.renderEmptyDayCell(c)), o === "next-month" && n++;
        }
      }
      r.push(this.renderWeekRow(s));
    }
    return r;
  }
  /**
   * Date validation
   */
  isExcluded(t) {
    return Tt(t, this.getDateConstraints());
  }
  /**
   * Month navigation
   */
  isPrevMonthAllowed() {
    return Je(this.year, this.month, this.earliest);
  }
  prevMonth() {
    const t = this.month === 0 ? 11 : this.month - 1, e = this.month === 0 ? this.year - 1 : this.year;
    this.changeMonth(e, t);
  }
  isNextMonthAllowed() {
    return Ze(this.year, this.month, this.latest);
  }
  nextMonth() {
    const t = this.month === 11 ? 0 : this.month + 1, e = this.month === 11 ? this.year + 1 : this.year;
    this.changeMonth(e, t);
  }
  changeMonth(t, e) {
    this.year = typeof t == "string" ? parseInt(t) : t, this.month = typeof e == "string" ? parseInt(e) : e, this.currentmonth = A(new Date(this.year, this.month, 1)), this.tabIndexSet = 0, this.focusedDate = null, this.selectableDates = [];
  }
  /**
   * Date selection logic
   */
  emptySelected() {
    this.selected = [], this._selected = [], this.inRange = {};
  }
  normalizeSelected() {
    return typeof this.selected == "string" ? this.selected.split(",") : this.selected;
  }
  addToSelected(t) {
    this.selected = tt(t, this.normalizeSelected()), this._selected = _(this.selected), this.range && this.selected.length === 2 && (this.convertSelected(), this.close());
  }
  removeFromSelected(t) {
    this.selected = et(t, this.normalizeSelected()), this._selected = _(this.selected);
  }
  toggleSelected(t) {
    this.selected = an(t, this.normalizeSelected(), this.maxMultiple), this._selected = _(this.selected);
  }
  isRangeAllowed(t) {
    return xt(t, this._selected, this.excludedates, this.excludeweekdays);
  }
  handleRangeSelect(t) {
    return this.selected = sn(t, this.normalizeSelected(), {
      excludedates: this.excludedates,
      excludeweekdays: this.excludeweekdays
    }), this._selected = _(this.selected), this.selected.length === 2 ? (this.convertSelected(), this.close()) : this.selected.length === 1 && (this.inRange = {}), Promise.resolve();
  }
  handleRangeHover(t) {
    if (!this.range || this._selected.length !== 1 || !this.isRangeAllowed(t) || this._selected[0] >= t) {
      this.rangeHovered = null;
      return;
    }
    this.rangeHovered = t, this.inRange = gt(this._selected[0], t);
  }
  handleDateSelect(t) {
    return t && (this.range ? this.handleRangeSelect(t) : this.multiple ? this.toggleSelected(t) : (this.selected.includes(y(t)) ? this.emptySelected() : (this.emptySelected(), this.addToSelected(t)), this.close()), this.dispatchEvent(
      new CustomEvent("date-selected", {
        detail: this.selected,
        bubbles: !0,
        composed: !0
      })
    )), Promise.resolve();
  }
  /**
   * Focus management and event handlers
   */
  focusOnCurrentDate() {
    const t = y(A(this.todayDate)), e = this.querySelector(`button[data-date="${t}"]`);
    if (e instanceof HTMLButtonElement) {
      this.focusedDate = t, e.focus();
      return;
    }
    const n = this.selectableDates.find((r) => !r.isDisabled);
    if (n) {
      const r = this.querySelector(
        `button[data-date="${n.currentDateISO}"]`
      );
      r instanceof HTMLButtonElement && (this.focusedDate = n.currentDateISO, r.focus());
    }
  }
  closeEvent(t) {
    !this.contains(t.relatedTarget) && !t.target.classList.contains("pkt-invisible") && this.close();
  }
  close() {
    this.dispatchEvent(
      new CustomEvent("close", {
        detail: !0,
        bubbles: !0,
        composed: !0
      })
    );
  }
};
h([
  f({ converter: z.csvToArray })
], l.prototype, "selected", 2);
h([
  f({ type: Boolean })
], l.prototype, "multiple", 2);
h([
  f({ type: Number, attribute: "max-multiple" })
], l.prototype, "maxMultiple", 2);
h([
  f({ type: Boolean })
], l.prototype, "range", 2);
h([
  f({ type: String })
], l.prototype, "earliest", 2);
h([
  f({ type: String })
], l.prototype, "latest", 2);
h([
  f({ converter: z.stringsToDate })
], l.prototype, "excludedates", 2);
h([
  f({ converter: z.csvToArray })
], l.prototype, "excludeweekdays", 2);
h([
  f({ type: Boolean })
], l.prototype, "weeknumbers", 2);
h([
  f({ type: Boolean })
], l.prototype, "withcontrols", 2);
h([
  f({ converter: z.stringToDate })
], l.prototype, "currentmonth", 2);
h([
  f({ type: String })
], l.prototype, "today", 2);
h([
  f({ type: Array, attribute: "day-strings" })
], l.prototype, "dayStrings", 2);
h([
  f({ type: Array, attribute: "day-strings-long" })
], l.prototype, "dayStringsLong", 2);
h([
  f({ type: Array, attribute: "month-strings" })
], l.prototype, "monthStrings", 2);
h([
  f({ type: String, attribute: "week-string" })
], l.prototype, "weekString", 2);
h([
  f({ type: String, attribute: "prev-month-string" })
], l.prototype, "prevMonthString", 2);
h([
  f({ type: String, attribute: "next-month-string" })
], l.prototype, "nextMonthString", 2);
h([
  f({ type: Array })
], l.prototype, "_selected", 2);
h([
  Z()
], l.prototype, "inRange", 2);
h([
  f({ type: Date })
], l.prototype, "rangeHovered", 2);
h([
  f({ type: Number })
], l.prototype, "year", 2);
h([
  f({ type: Number })
], l.prototype, "month", 2);
h([
  f({ type: Number })
], l.prototype, "week", 2);
h([
  Z()
], l.prototype, "currentmonthtouched", 2);
h([
  Z()
], l.prototype, "focusedDate", 2);
l = h([
  Nt("pkt-calendar")
], l);
export {
  l as P,
  wn as a,
  U as b,
  y as c,
  Sn as d,
  z as e,
  pn as f,
  Dn as i,
  W as n,
  O as p,
  bn as s,
  je as v
};
